import {
  AffectEnrollmentInput,
  AffectEnrollmentRequest,
  AffectEnrollmentsResponse
} from '../../lib/types/models/enrollment/affect-enrollment'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const affectEnrollments = (input: AffectEnrollmentInput[]) => {
  return restApiClient
    .url(constructApiUrl(API.centers.affectEnrollments.url, null))
    .post<AffectEnrollmentsResponse, AffectEnrollmentRequest[]>(
      input.map(({ blockedFriendIds, center, enrollmentId, centerGroupId }) => ({
        enrollmentId,
        blockedFriendIds,
        centerId: center?.id,
        centerGroupId
      }))
    )
}
